import React, { useState } from 'react';
import {
  CURRENT_RATES,
  PROTOCOL_CONSTANTS
} from '../constants/pricing';
import { fmtIcp, fmtN } from '../utils/formatters';

const StakingModal = ({ isOpen, onClose, userICP = 0 }) => {
  const [stakeAmount, setStakeAmount] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (!isOpen) return null;

  const icpAmount = parseFloat(stakeAmount) || 0;
  const hasInsufficientFunds = icpAmount > userICP;
  const nIcpReceived = icpAmount * CURRENT_RATES.icpToNICP_staking;
  const wtnAirdrop = (icpAmount / 100) * PROTOCOL_CONSTANTS.WTN_PER_100_ICP;

  const handleMaxClick = () => {
    setStakeAmount(userICP.toString());
  };

  const handleStake = () => {
    if (hasInsufficientFunds || icpAmount <= 0) return;
    setShowConfirmation(true);
  };

  const handleConfirmStake = () => {
    // TODO: Implement actual staking logic
    console.log('Staking confirmed:', {
      amount: icpAmount,
      nIcpReceived,
      wtnAirdrop
    });
    setShowConfirmation(false);
    onClose();
  };

  const handleCancelConfirmation = () => {
    setShowConfirmation(false);
  };

  if (showConfirmation) {
    return (
      <div className="modal-overlay" onClick={handleCancelConfirmation}>
        <div className="staking-confirmation-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Confirm Staking</h2>
            <button className="modal-close" onClick={handleCancelConfirmation}>
              ✕
            </button>
          </div>
          
          <div className="confirmation-content">
            <div className="confirmation-details">
              <h3>Transaction Summary</h3>
              <div className="detail-row">
                <span>Stake Amount:</span>
                <span><strong>{fmtIcp(icpAmount)} ICP</strong></span>
              </div>
              <div className="detail-row">
                <span>You will receive:</span>
                <span><strong>{fmtN(nIcpReceived)} nICP</strong></span>
              </div>
              <div className="detail-row">
                <span>Future WTN Airdrop:</span>
                <span><strong>{wtnAirdrop.toFixed(1)} WTN</strong></span>
              </div>
              <div className="detail-row">
                <span>Exchange Rate:</span>
                <span>1 ICP = {fmtN(CURRENT_RATES.icpToNICP_staking)} nICP</span>
              </div>
            </div>
            
            <div className="confirmation-actions">
              <button className="cancel-button" onClick={handleCancelConfirmation}>
                Cancel
              </button>
              <button className="confirm-button" onClick={handleConfirmStake}>
                Confirm Stake
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="staking-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <span className="modal-icon">🥩</span>
            <h2>Stake ICP</h2>
          </div>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div className="staking-tabs">
            <div className="tab active">Stake ICP</div>
            <div className="tab inactive">Unstake nICP</div>
          </div>

          <div className="staking-form">
            <div className="input-section">
              <div className="input-container">
                <input
                  type="number"
                  value={stakeAmount}
                  onChange={(e) => setStakeAmount(e.target.value)}
                  className="stake-amount-input"
                  placeholder="0"
                  min="0"
                  step="0.1"
                />
                <div className="input-suffix">
                  <button className="max-button" onClick={handleMaxClick}>
                    MAX
                  </button>
                  <div className="token-info">
                    <span className="token-symbol">ICP</span>
                    <div className="token-icon">∞</div>
                  </div>
                </div>
              </div>
            </div>

            {hasInsufficientFunds && icpAmount > 0 && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                You don't have enough funds to complete the transaction.
              </div>
            )}

            <div className="transaction-info">
              <div className="receive-amount">
                You will receive <strong>{fmtN(nIcpReceived)} nICP</strong>
              </div>
              
              <div className="exchange-rate">
                <span className="rate-icon">⇄</span>
                1 ICP = {fmtN(CURRENT_RATES.icpToNICP_staking)} nICP
                <span className="expand-icon">↗</span>
              </div>
              
              <div className="airdrop-info">
                <span className="airdrop-label">Future WTN Airdrop:</span>
                <span className="airdrop-amount">{wtnAirdrop.toFixed(1)}</span>
                <span className="airdrop-icon">🧠</span>
              </div>
            </div>

            <button 
              className={`stake-button ${hasInsufficientFunds || icpAmount <= 0 ? 'disabled' : ''}`}
              onClick={handleStake}
              disabled={hasInsufficientFunds || icpAmount <= 0}
            >
              Stake
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StakingModal;
